// Module
var code = `<div class="upgrade-client"><p class="message" compile="message"></p><p ng-if="showUpgradeInstructions" class="message">{{::clientConfig.upgradeInstructions}}</p><button type="button" class="modal-action-button continue" click-key="ENT" ng-click="onClickButton()"><span>{{::buttonText}}</span></button></div>`;
// Exports
export default code;